const YM_COUNTER_ID = 107040403
const BLOCK_READ_GOAL = 'hub2026_block_read'
const BLOCK_READ_SELECTOR = 'section'
const BLOCK_READ_THRESHOLD = 0.5
const EXCLUDED_BLOCK_CLASSES = ['spacer', 'modal-block', 'cookie-consent']

const safeReachGoal = (goal, params = {}) => {
    try {
        // eslint-disable-next-line no-undef
        if (typeof ym === 'function') {
            // eslint-disable-next-line no-undef
            ym(YM_COUNTER_ID, 'reachGoal', goal, params)
        }
        // eslint-disable-next-line no-empty
    } catch (error) {}
}

const onDomReady = (handler) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handler, { once: true })

        return
    }

    handler()
}

const normalizeParams = (dataset) => {
    const params = {}

    Object.keys(dataset).forEach((key) => {
        if (key === 'ymGoal') {
            return
        }

        const rawValue = dataset[key]
        // eslint-disable-next-line no-undefined
        if (rawValue === undefined || rawValue === null || rawValue === '') {
            return
        }

        // dataset uses camelCase, convert to snake_case for readability
        const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()

        params[snakeKey] = rawValue
    })

    return params
}

const deriveBlockFromDom = (el) => {
    const section = el.closest('section')
    if (section) {
        const className = (section.getAttribute('class') || '').split(/\s+/).filter(Boolean).shift()

        if (className) {
            return className
        }
    }

    if (el.closest('header')) {
        return 'header'
    }

    if (el.closest('footer')) {
        return 'footer'
    }

    return 'unknown'
}

const hasExcludedBlockClass = (el) => {
    if (!el) {
        return false
    }

    return EXCLUDED_BLOCK_CLASSES.some((className) => el.classList.contains(className))
}

const getSectionBlockName = (section) => {
    if (!section) {
        return ''
    }

    const className = Array.from(section.classList).find((item) => item && !item.startsWith('js-'))

    return className || ''
}

const getTrackableSections = (root = document) => {
    if (!root) {
        return []
    }

    return Array.from(root.querySelectorAll(BLOCK_READ_SELECTOR)).filter(
        (section) => !hasExcludedBlockClass(section),
    )
}

const buildBlockReadParams = (section, index) => {
    const blockName = getSectionBlockName(section)

    return {
        // eslint-disable-next-line camelcase
        ym_block: blockName || deriveBlockFromDom(section),
        // eslint-disable-next-line camelcase
        ym_block_index: String(index + 1),
        // eslint-disable-next-line camelcase
        ym_block_anchor: section.id || '',
    }
}

const trackVisibleSections = () => {
    if (typeof window.IntersectionObserver !== 'function') {
        return
    }

    const sections = getTrackableSections()

    if (!sections.length) {
        return
    }

    const seenSections = new WeakSet()
    const observer = new window.IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting || entry.intersectionRatio < BLOCK_READ_THRESHOLD) {
                    return
                }

                const section = entry.target

                if (seenSections.has(section)) {
                    return
                }

                seenSections.add(section)

                const index = sections.indexOf(section)

                safeReachGoal(BLOCK_READ_GOAL, buildBlockReadParams(section, index))
                observer.unobserve(section)
            })
        },
        {
            threshold: BLOCK_READ_THRESHOLD,
        },
    )

    sections.forEach((section) => observer.observe(section))
}

// Expose a tiny API for other scripts (form submit success, errors, etc.)
window.optiYm = window.optiYm || {}
window.optiYm.reachGoal = (goal, params = {}) => safeReachGoal(goal, params)

// Delegate click tracking. This must be attached even if the script is loaded
// after DOMContentLoaded (e.g. because of async loading).
document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-ym-goal]')
    if (!target) {
        return
    }

    const goal = target.dataset.ymGoal
    if (!goal) {
        return
    }

    const params = normalizeParams(target.dataset)

    if (!params.ym_block) {
        // eslint-disable-next-line camelcase
        params.ym_block = target.dataset.ymBlock || deriveBlockFromDom(target)
    }

    if (!params.ym_cta) {
        // eslint-disable-next-line camelcase
        params.ym_cta = target.dataset.ymCta || 'default'
    }

    safeReachGoal(goal, params)
})

const attachSimpleClickGoal = (selector, goal, extraParams = {}) => {
    document.querySelectorAll(selector).forEach((el) => {
        el.addEventListener('click', () => {
            const params = {
                ...extraParams,
                // eslint-disable-next-line camelcase
                ym_block: extraParams.ym_block || deriveBlockFromDom(el),
            }
            safeReachGoal(goal, params)
        })
    })
}

onDomReady(() => {
    attachSimpleClickGoal('.site-footer__contacts--tel', 'hub2026_contact_phone_click', {
        // eslint-disable-next-line camelcase
        ym_block: 'footer',
    })
    attachSimpleClickGoal('.site-footer__contacts--mail', 'hub2026_contact_email_click', {
        // eslint-disable-next-line camelcase
        ym_block: 'footer',
    })

    trackVisibleSections()
})
